import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { axiosInstance } from '../../lib/axio';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AuthPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');


  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert('All fields are required.');
      return;
    }
    if (isLogin) {
      try {
        // Simulate an API request for login
        // Replace this with your actual login logic, such as an API call to check credentials
        const response = await axiosInstance.post('/user/login', { username, password });
        console.log("login response:", response);
        if (response.status === 200) {
          login();
          alert("Logged in successfully!");
          navigate("/blogs/create");
          window.scrollTo(0, 0);
        } else {
          alert(response.data.message);
          console.log("response error : ", response);
        }
      } catch (error) {
        alert(error.response?.data?.message || 'Unable to log in. Check your credentials.');
        console.log(error)
      }
    }
    else {
      try {
        const response = await axiosInstance.post("/user/signup", {
          name,
          username,
          password,
        });
        console.log("signup response:", response);
        if (response.status === 201) {
          login();
          alert("Signed up successfully!");

          navigate('/blogs/create')
          window.scrollTo(0, 0);
        } else {
          alert(response.data.message || 'Something went wrong. Please try again.');
        }
      } catch (error) {
        alert(error.response?.data?.message || 'Unable to sign up. Please try again.');
      }
    }
  }

  const toggleAuthMode = () => {
    setIsLogin((prevMode) => !prevMode);
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">
      <motion.div
        className="w-full max-w-md p-6"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="bg-white shadow-2xl rounded-2xl">
          <div className="p-8">
            <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
              {isLogin ? 'Login' : 'Sign Up'}
            </h2>

            <form onSubmit={handleOnSubmit}>
              {!isLogin && (
                <div className="mb-4">
                  <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => { setName(e.target.value) }}
                    className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter your name"
                  />
                </div>
              )}

              <div className="mb-4">
                <label htmlFor="username" className="block text-gray-700 text-sm font-bold mb-2">
                  username
                </label>
                <input
                  type="username"
                  id="username"
                  value={username}
                  onChange={(e) => { setUsername(e.target.value) }}
                  className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="Enter your username"
                />
              </div>

              <div className="mb-4">
                <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value) }}
                  className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="Enter your password"
                />
              </div>

              <button className="w-full py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-lg">
                {isLogin ? 'Login' : 'Sign Up'}
              </button>
            </form>

            <p className="text-center text-sm text-gray-600 mt-4">
              {isLogin ? "Don't have an account?" : 'Already have an account?'}{' '}
              <button
                onClick={toggleAuthMode}
                className="text-blue-600 hover:underline focus:outline-none"
              >
                {isLogin ? 'Sign Up' : 'Login'}
              </button>
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AuthPage;

